import * as React from "react";

export interface Props {
  className: string;
}

const MenuIcon = ({ className }: Props) => (
  <svg className={className} width="22px" height="18px" viewBox="0 0 22 18">
    <path d="M0,2 L20,2" strokeWidth="2" />
    <path d="M0,9 L20,9" strokeWidth="2" />
    <path d="M0,16 L20,16" strokeWidth="2" />
  </svg>
);

export default MenuIcon;
